module.exports = __webpack_public_path__ + "img/w22-b1.e70c5c0a.jpg";